import React, { FC, memo } from 'react'

import { Loader, ErrorHandler } from 'components'
import { makeTraceDetails } from 'common'

import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'

import { DontDisturbBottomsheetView } from './DontDisturbBottomsheeView'
import { TDontDisturbBottonsheetProps } from '../types/DontDisturbBottomsheet.types'
import { useDontDisturbBottomSheet } from '../hooks/useDontDisturbBottomsheet'

export const DontDisturbBottomsheet: FC<TDontDisturbBottonsheetProps> = memo(({ onClose }) => {
  const { isAppLoading, isErrorOrInactive, content } = useDontDisturbBottomSheet()

  if (isAppLoading) return <Loader />

  if (isErrorOrInactive || content === undefined) {
    const traceDetails = makeTraceDetails(isErrorOrInactive, content)

    return <ErrorHandler traceDetails={traceDetails} componentName={DontDisturbBottomsheet.name} />
  }

  const { confirmButton, details, site, title, icon } = content

  return (
    <BottomSheet onClose={onClose}>
      <DontDisturbBottomsheetView
        icon={icon}
        title={title}
        details={details}
        site={site}
        confirmButton={confirmButton}
        onClose={onClose}
      />
    </BottomSheet>
  )
})
